import { ToastContainer, toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { API_BASE_URL } from "../../../config";
import { getAuthToken } from "../../../auth/auth";

import JobStatus from "../../../components/JobStatus";
import Loader from "../../../components/Loader";

import CandidatesCard from "./CandidatesCard";

export default function CandidatesPage() {
  const [candidates, setCandidates] = useState([]);
  const [jobInfo, setJobInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [closingJob, isClosingJob] = useState(false);
  const param = useParams();
  const token = getAuthToken();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCandidates = async () => {
      setIsLoading(true);
      const response = await fetch(
        `${API_BASE_URL}/job/${param.id}/candidates`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Response("Failed to fetch candidates", {
          status: response.status,
        });
      }

      const result = await response.json();
      setCandidates(result.candidates);
      setJobInfo(result.job);
      setIsLoading(false);
    };

    handleCandidates();
  }, []);

  const handleCloseJob = async () => {
    const jobId = param.id;

    try {
      isClosingJob(true);
      const response = await fetch(
        `${API_BASE_URL}/company/close-job/${jobId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to close job.");
      }

      const result = await response.json();
      toast.success("Job closed!");
      isClosingJob(false);
      navigate("/my-jobs");
    } catch {
      toast.error("Failed to close job.");
      isClosingJob(false);
    }
  };

  return (
    <>
      <section id="candidates_page_hero">
        <div className="container">
          <div className="job-card-single__all">
            <div className="row-essy items-center-essy">
              <div className="col-essy-lg-6 col-essy-md-6">
                <div className="job-cart-header">
                  <span>Job Name</span>
                  <h4>{jobInfo?.title}</h4>
                </div>
              </div>
              <div className="col-essy-lg-6 col-essy-md-6">
                {isLoading ? (
                  <Loader />
                ) : (
                  <JobStatus status={jobInfo?.status} />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="candidates">
        <div className="container">
          <div className="candidates-top-title">
            <div className="row-essy">
              <div className="col-essy-lg-6 col-essy-md-6">
                <h2>Candidates</h2>
              </div>
              <div className="col-essy-lg-6 col-essy-md-6">
                <div className="close-job-wrapper">
                  {!isLoading && jobInfo?.status !== 2 && (
                    <button
                      className={`btn-all-white ${
                        closingJob ? "disabled" : ""
                      }`}
                      onClick={handleCloseJob}
                    >
                      {closingJob ? "Closing Job" : "Close Job"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          {isLoading ? <Loader /> : <CandidatesCard candidates={candidates} />}
        </div>
      </section>
    </>
  );
}
